import { render, staticRenderFns } from "./modal-after-upgrade.vue?vue&type=template&id=6c199ab4&"
import script from "./modal-after-upgrade.vue?vue&type=script&lang=js&"
export * from "./modal-after-upgrade.vue?vue&type=script&lang=js&"
import style0 from "./modal-after-upgrade.vue?vue&type=style&index=0&id=6c199ab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports